// function to determine if the user has the correct role
export function userHasRole(roleName: string, roles: Array<Record<string,string>>): boolean {
    for (let i = 0; i < roles.length; i++) {
        return roles[i].sid.toUpperCase() === roleName.toUpperCase();
    }
    return false;
}

// function to automatically scroll to price input
export function scrollToPriceInput(element: string): void {
    setTimeout(() => {
        const priceLabel = document.querySelector(element) as HTMLLabelElement;
        if (priceLabel) {
            const inputId = priceLabel.getAttribute("for");
            if (inputId) {
                const priceInput = document.getElementById(inputId) as HTMLInputElement;
                if (priceInput) {
                    priceInput.focus();
                    priceInput.scrollIntoView({ 
                        behavior: "smooth", 
                        block: "center" 
                    });
                }
            }
        }
    }, 100);
}

// function to automatically scroll to an input by id
export function scrollToElementById(element: string): void {
    setTimeout(() => {
        const input = document.getElementById(element) as HTMLInputElement;
        if (input) {
            input.focus();
            input.scrollIntoView({ 
                behavior: "smooth", 
                block: "center" 
            });
        }
    }, 100);
}

// function to automatically scroll to an input by query selector
export function scrollToElementByQuerySelector(element: string): void {
    setTimeout(() => {
        const input = document.querySelector(element) as HTMLInputElement;
        if (input) {
            input.focus();
            input.scrollIntoView({ 
                behavior: "smooth", 
                block: "center" 
            });
        }
    }, 100);
}